'use strict';

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// var resizeWells = debounce(function(selector) {
//     var elementsToChange = [];
//     var elementsChanged = [];

//     var maxHeight = 0;
//     jQuery(selector).each(function (index, value) {
//         jQuery(value).css('minHeight', 'auto');

//         if (maxHeight < jQuery(value).outerHeight()) {
//             maxHeight = jQuery(value).outerHeight();
//             elementsToChange = elementsChanged;
//         }

//         jQuery(value).css('minHeight', maxHeight );

//         elementsChanged.push(jQuery(value));
//     });

//     elementsToChange.forEach(function (element) {
//         element.css('minHeight', maxHeight );
//     });
// },250);
function resizeWells(selector) {
    var elementsToChange = [];
    var elementsChanged = [];

    var maxHeight = 0;
    jQuery(selector).each(function (index, value) {
        jQuery(value).css('minHeight', 'auto');

        if (maxHeight < jQuery(value).outerHeight()) {
            maxHeight = jQuery(value).outerHeight();
            elementsToChange = elementsChanged;
        }

        jQuery(value).css('minHeight', maxHeight);

        elementsChanged.push(jQuery(value));
    });

    elementsToChange.forEach(function (element) {
        element.css('minHeight', maxHeight);
    });
}

function resizeWellsHeight(selector) {
    var elementsToChange = [];
    var elementsChanged = [];

    var maxHeight = 0;
    jQuery(selector).each(function (index, value) {
        jQuery(value).css('height', 'auto');

        if (maxHeight < jQuery(value).outerHeight()) {
            maxHeight = jQuery(value).outerHeight();
            elementsToChange = elementsChanged;
        }

        jQuery(value).css('height', maxHeight);

        elementsChanged.push(jQuery(value));
    });

    elementsToChange.forEach(function (element) {
        element.css('height', maxHeight);
    });
}

function resizeWellsConditional(selector, width) {
    if (jQuery(window).width() > width) {
        resizeWells(selector);
    } else {
        jQuery(selector).css('minHeight', 'auto');
    }
}

function emptySearch() {
    if (!jQuery('.search-input').val()) {
        jQuery('.search-submit').prop('disabled', true);
    } else {
        jQuery('.search-submit').prop('disabled', false);
    }
}

function pad(n) {
    if (n.toString().length == 1) {
        return '0' + n;
    } else {
        return n;
    }
}

function shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

    return "#" + RR + GG + BB;
}

function countdown(date, target) {
    // Update the count down every 1 second
    var x = setInterval(function () {

        var now = moment().tz("Pacific/Honolulu").unix() * 1000;
        // console.log(now);

        // Get todays date and time
        // var now = new Date().getTime();

        // Find the distance between now an the count down date
        var distance = date - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(distance % (1000 * 60) / 1000);

        var container = document.querySelector(target);
        var daysTarget = container.querySelector('.days');
        var hoursTarget = container.querySelector('.hours');
        var minutesTarget = container.querySelector('.minutes');
        var secondsTarget = container.querySelector('.seconds');

        daysTarget.innerHTML = pad(days) + '';
        hoursTarget.innerHTML = pad(hours) + '';
        minutesTarget.innerHTML = pad(minutes) + '';
        secondsTarget.innerHTML = pad(seconds);

        // If the count down is finished, write some text 
        if (distance < 0) {
            clearInterval(x);

            daysTarget.innerHTML = '00';
            hoursTarget.innerHTML = '00';
            minutesTarget.innerHTML = '00';
            secondsTarget.innerHTML = '00';
        }
    }, 1000);
}

function popupVid(vid) {
    vid = vid.replace('watch?v=', 'embed/');
    if (jQuery('#vid-lightbox').length === 0) {
        jQuery('body').append('<div id="vid-lightbox" class="vid-lightbox" onclick="closePopup()"><div id="vid-lightbox__inner" class="vid-lightbox__inner"></div></div>');
    } else {
        jQuery('#vid-lightbox__inner').empty();
    }
    var iframe = '<iframe width="560" height="315" frameborder="0" alllowfullscreen src="' + vid + '"></iframe><button class="lightbox__close" onclick="closePopup();"><i class="icon-icon--close" aria-hidden="true"></i><span class="sr-only">Close</span></button>';
    var lightbox = jQuery('#vid-lightbox');
    lightbox.find('#vid-lightbox__inner').append(iframe).end().fadeIn();
}

function closePopup() {
    jQuery('#vid-lightbox').fadeOut('fast', function () {
        jQuery('#vid-lightbox').remove();
    });
}

function trackRegister() {
    goog_conv_custom('856684232', '7iB8CJyO_XAQyO2_mAM');
    fbq('track', 'CompleteRegistration');
}

function trackContact() {
    goog_conv_custom('856684232', '6OJdCI6D6XIQyO2_mAM');
}

function trackPreReg() {
    goog_conv_custom('856684232', 'iEeHCPmb_28QyO2_mAM');
}

function chartToggle() {
    var toggle = document.getElementById('chartToggle');
    var firstLabel = document.querySelector('.labels .chart-1');
    var secondLabel = document.querySelector('.labels .chart-2');
    var firstChart = document.querySelector('.event__chart.chart-1');
    var secondChart = document.querySelector('.event__chart.chart-2');
    if (toggle.checked) {
        secondLabel.style.opacity = '0';
        secondChart.style.display = 'none';
        firstLabel.style.opacity = '1';
        firstChart.style.display = 'block';
    } else {
        firstLabel.style.opacity = '0';
        firstChart.style.display = 'none';
        secondLabel.style.opacity = '1';
        secondChart.style.display = 'block';
    }
}

var adjustHeroLines = debounce(function () {
    var textWidth = jQuery('.slick-active .hero__link-text__inner').outerWidth() + 60;
    var parentWidth = jQuery('.hero__link-text').outerWidth();
    jQuery('.slick-active .hero__link-text .line').each(function () {
        jQuery(this).width((parentWidth - textWidth) / 2);
    });
}, 250);

var submitted = false;
function checkForm() {
    setTimeout(function () {
        if (jQuery('#mce-success-response').text().length > 0 && !submitted) {
            trackPreReg();
            submitted = true;
        }
    }, 1000);
}

(function ($, root, undefined) {

    $(function () {

        'use strict';

        if ($('.header__countdown').length) {
            var dateFormatted = moment.tz($('.header__countdown').attr('data-date'), "MM/DD/YYYY HH:mm:s", "Pacific/Honolulu");

            countdown(dateFormatted, '.header__countdown');
            countdown(dateFormatted, '.countdown-mob .header__countdown');
        }

        $("#mobile-menu").mmenu({
            "offCanvas": {
                "position": "right"
            }
        });

        emptySearch();

        $('.search__toggle').on('click', function () {
            $(this).parents('form').toggleClass('in');
            setTimeout(function () {
                if ($('.search').hasClass('in')) {
                    $('.search-input').focus();
                }
            }, 500);
        });

        $('.search-input').keyup(function () {
            emptySearch();
        });

        $('.hero:not(.hero--sm)').on('init', function (slick) {
            setTimeout(function () {
                adjustHeroLines();
            }, 100);
            setTimeout(function () {
                $('.hero__slide.slick-active .hero__text').animate({
                    'opacity': '1'
                }, 400);
            }, 300);
        });

        $('.hero:not(.hero--sm)').slick({
            slidesToShow: 1,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Next</span></button>',
            infinite: false,
            responsive: [{
                breakpoint: 991,
                settings: {
                    arrows: false
                }
            }]
        });

        $('.hero:not(.hero--sm)').on('afterChange', function (slick, currentSlide) {
            adjustHeroLines();
            $('.hero__slide:not(.slick-active) .hero__text').animate({
                'opacity': '0'
            }, 250);
            $('.hero__slide.slick-active .hero__text').animate({
                'opacity': '1'
            }, 250);
        });

        $('.past-results__slider').slick({
            variableWidth: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Next</span></button>',
            infinite: false,
            slidesToScroll: 2
        });

        $('.testimonial-slider').on('afterChange', function (slick, currentSlide) {
            var color = $(this).attr('data-color');
            var colorDarker = shadeColor(color, 50);
            $(this).find('.slick-dots li').each(function () {
                if ($(this).hasClass('slick-active')) {
                    $(this).css('backgroundColor', color);
                } else {
                    $(this).css('backgroundColor', colorDarker);
                }
            });
        });

        if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
            $('html').addClass('ie10');
        }

        $('.testimonial-slider').on('init', function (slick) {
            var color = $(this).attr('data-color');
            var colorDarker = shadeColor(color, 50);
            $(this).find('.slick-dots li').each(function () {
                if ($(this).hasClass('slick-active')) {
                    $(this).css('backgroundColor', color);
                } else {
                    $(this).css('backgroundColor', colorDarker);
                }
            });
        });

        $('.testimonial-slider').slick({
            arrows: false,
            dots: true,
            adaptiveHeight: true
        });

        if ($('.gallery').length !== 0) {
            $('.gallery__tiles').slickLightbox({
                slick: {
                    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Previous</span></button>',
                    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Next</span></button>'
                }
            });
        }

        // WAYPOINTS - HOME
        var ppWaypoint = $('.fade-element').waypoint(function (direction) {
            if (direction == 'down') {
                $(this.element).addClass('waypoint-show');
                this.destroy();
            }
        }, {
            offset: '90%'
        });

        setTimeout(function () {
            resizeWellsConditional('.feat-news__text', 992);
            resizeWellsConditional('.feat-news__title-outer', 992);
            resizeWells('.sponsor__title');
        }, 500);

        $(window).resize(function () {
            resizeWellsConditional('.feat-news__text', 992);
            // resizeWellsConditional('.feat-news__title', 992);
            resizeWells('.sponsor__title');

            if ($('.line').length) {
                adjustHeroLines();
            }
        });

        $('a[href="http://bit.ly/Enter2018Hapalua"]').on('click', function () {
            trackRegister();
        });

        if ($('#chartToggle').length) {
            // if event page with charts
            chartToggle();
        }

        // custom radio buttons
        $('input[type="radio"]').each(function () {
            $(this).after('<span class="radio-clone"></span>');
        });

        $('.wpcf7-radio span:not(.wpcf7-list-item)').click(function () {
            $(this).prevUntil('.input[type="radio"]').prop('checked', true).attr('checked', 'checked');
        });

        // rsponsive youtube
        $('iframe[src*="youtube"]').each(function () {
            $(this).wrap('<div class="iframe-container"></div>');
        });

        $('a[href="#"]').on('click', function (e) {
            e.preventDefault();
        });

        if ($('#runnerGroupsTab').length) {
            $('#runnerGroupsTab').tabCollapse();
            $('#runnerGroupsTab').on('shown-accordion.bs.tabcollapse', function () {
                var accordion = $('#runnerGroupsTab-accordion');
                accordion.appendTo($(this).parent().next());
                accordion.find('.nav-btn').each(function () {
                    var parent = $(this).parents('.panel');
                    var content = parent.find('.panel-body');
                    $(this).removeClass('btn').addClass('accordion__title');
                    parent.find('.panel-heading').remove();
                    parent.prepend($(this)).removeClass('panel panel-default').addClass('accordion');
                    content.removeClass('panel-body').addClass('accordion__content');
                });
            });
        }

        $('.person a').on('click', function () {
            var personCopy = $(this).parents('.person').clone();
            personCopy.find('.feat-news__img a').each(function () {
                var innerHTML = $(this).html();
                $(this).parent().append(innerHTML);
                $(this).remove();
            });

            personCopy.find('.person__excerpt').hide().end().find('.person__full').removeClass('hidden').end().find('.feat-news__link').hide();
            var modal = $('#runnerModal');
            modal.find('.modal__inner').empty();

            modal.html(personCopy).find('.feat-news__img').append('<button class="modal__close"><i class="icon icon-icon--close"></i><span class="sr-only">Close</span></button>').end().addClass('visible').animate({
                'opacity': '1'
            }, 400);
        });

        $(document).on('click', '.modal__close', function () {
            var modal = $('#runnerModal');
            modal.removeClass('visible');
        });

        $(document).on('click', function (e) {
            if ($('.modal').length) {
                if ($('.modal').hasClass('visible')) {
                    if (e.target.id == 'runnerModal') {
                        var modal = $('#runnerModal');
                        modal.removeClass('visible');
                    }
                }
            }
        });

        $(document).on('click touchstart', '.header__top--close', function () {
            $(".header__top").slideUp("slow");
        });

        $(document).on('click touchstart', '.header__top--open', function () {
            $(".header__top").slideDown("slow");
        });
    });
})(jQuery, undefined);